import type { TFunction } from 'i18next';

/** Map server/API status strings to i18n keys under `status.*`. */
export function translateInvoiceStatus(status: string | null | undefined, t: TFunction): string {
  if (!status) return '';
  const key = status.toLowerCase().replace(/\s+/g, '_');
  return t(`status.${key}`, { defaultValue: status });
}

export function translatePaymentMethod(method: string | null | undefined, t: TFunction): string {
  if (!method) return '';
  const key = method.toLowerCase().replace(/\s+/g, '_');
  return t(`paymentMethod.${key}`, { defaultValue: method });
}

const ROLE_KEYS: Record<string, string> = {
  'Company Admin': 'company_owner',
  Cashier: 'cashier',
  Manager: 'manager',
};

export function translateRole(role: string | null | undefined, t: TFunction): string {
  if (!role) return '';
  const key = ROLE_KEYS[role];
  if (key) return t(`users.roles.${key}`);
  return role;
}
